/**
 * Хранение внешней сессии учителя на клиенте.
 *
 * Cookie `_teacher_key` (HttpOnly, 30 суток с продлением) остаётся основной:
 * она недоступна из JS и защищена от XSS. Но она теряется вместе с cookie-банкой
 * браузера — встроенный браузер мессенджера, очистка данных сайта, другой
 * профиль. Поэтому облако дополнительно отдаёт `restore_token`, который SPA
 * хранит в localStorage и предъявляет, если сессия «слетела», а строка сессии на
 * сервере ещё жива.
 *
 * Профиль лежит в sessionStorage (одна вкладка, живёт до её закрытия).
 * Все обращения к хранилищам обёрнуты в try/catch: в приватном режиме запись
 * может быть запрещена, и тогда кабинет просто работает на одной cookie.
 */

const PROFILE_KEY = "profile";
const RESTORE_TOKEN_KEY = "teacher_restore_token";

function readRaw(storage, key) {
  try {
    return storage.getItem(key);
  } catch (e) {
    return null;
  }
}

function writeRaw(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch (e) {
    // Хранилище недоступно — работаем без него.
  }
}

function removeRaw(storage, key) {
  try {
    storage.removeItem(key);
  } catch (e) {
    // pass
  }
}

/** Профиль учителя из sessionStorage или null. */
export function readProfile() {
  const raw = readRaw(sessionStorage, PROFILE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

/** Восстановительный токен из localStorage или null. */
export function readRestoreToken() {
  const token = readRaw(localStorage, RESTORE_TOKEN_KEY);
  return token && token.trim() ? token : null;
}

/** Забыть восстановительный токен (выход, отказ сервера). */
export function clearRestoreToken() {
  removeRaw(localStorage, RESTORE_TOKEN_KEY);
}

/**
 * Сохранить ответ входа или восстановления.
 *
 * Профиль — в sessionStorage; `restore_token`, если облако его вернуло, — в
 * localStorage. Если токена в ответе нет (например, внутренняя площадка со
 * входом по паролю), уже сохранённый токен не трогаем.
 */
export function saveSession(payload) {
  if (!payload) return;

  const { restore_token: restoreToken, ...profile } = payload;

  writeRaw(sessionStorage, PROFILE_KEY, JSON.stringify(profile));
  if (restoreToken) writeRaw(localStorage, RESTORE_TOKEN_KEY, restoreToken);
}

/** Полная очистка клиентской сессии (выход). */
export function clearSession() {
  removeRaw(sessionStorage, PROFILE_KEY);
  clearRestoreToken();
}
